import { isInsideBrowser } from 'common/src/vtj/browser/browser-util'

export function setDocumentTitle(title) {
  if (isInsideBrowser() && document.title !== title) {
    document.title = title
  }
}
